module.exports = __webpack_public_path__ + "static/Feature3-6b7f243bc0969ae37f14767f95abf5a1.jpg";